import ApolloClient from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloLink } from 'apollo-link'
import { createLink } from '../../utils/libs/apollo-absinthe-upload-link'
import * as AbsintheSocket from '@absinthe/socket';
import { map } from 'rxjs/operators';
import env from '../../config/environment'

export default class GraphQL {
    constructor(EfSocket, renewTokenInterceptor, rateLimiting, EfLockScreenService, $injector) {
        this.rateLimiting = rateLimiting
        this.EfLockScreenService = EfLockScreenService
        this.$injector = $injector

        const headersMiddleware = new ApolloLink((operation, forward) => {
            const mapOperation = response => {
                renewTokenInterceptor.context(operation.getContext())
                return response
            }

            const observable = forward(operation)

            // Por algum motivo esta vindo um Observable com uma operação de map. :(
            return observable.pipe ? observable.pipe(map(mapOperation)) : observable.map(mapOperation)
        })

        this.client = new ApolloClient({
            link: headersMiddleware.concat(createLink({ uri: env.graphql_url })),
            cache: new InMemoryCache(),
            defaultOptions: {
                query: {
                    fetchPolicy: 'network-only'
                }
            }
        })

        this.EfSocket = EfSocket
        this.socketIsConnected = false
    }

    async query(query, variables = {}, options = {}) {
        options.context = options.context || {}
        options.context.headers = cbk.getHeaders()
        options.errorPolicy = options.errorPolicy || 'all'
        const UsuariosService = this.$injector.get('UsuariosService')

        try {
            const { data, errors } = GraphQL.deepUnfreeze(await this.client.query({ query, variables, ...options }))

            if (errors) {
                if (errors.some(e => e.message === "unauthenticated")) {
                    await this.EfLockScreenService.show(UsuariosService.usuarioLogado)

                    return await this.query(query, variables, options)
                }
                return Promise.reject(errors)
            } else {
                return data
            }
        } catch (errors) {
            if (errors.networkError.statusCode === 403) {
                await this.EfLockScreenService.show(UsuariosService.usuarioLogado)

                return await this.query(query, variables, options)
            }

            if (errors.networkError.statusCode === 429) {
                return this.rateLimiting.wait(() => this.query(query, variables, options), errors.networkError.response.headers.get('ttl'))
            }

            throw errors
        }
    }

    async mutate(mutation, variables = {}, options = {}) {
        options.context = options.context || {}
        options.context.headers = cbk.getHeaders()
        options.errorPolicy = options.errorPolicy || 'all'
        const UsuariosService = this.$injector.get('UsuariosService')

        const { data, errors } = GraphQL.deepUnfreeze(await this.client.mutate({ mutation, variables, ...options }))

        try {
            if (errors) {
                if (errors.some(e => e.message === "unauthorized")) {
                    await this.EfLockScreenService.show(UsuariosService.usuarioLogado)

                    return await this.mutate(mutation, variables, options)
                }

                return Promise.reject(errors)
            } else {
                return data
            }
        } catch (errors) {
            if (errors.networkError.statusCode === 403) {
                await this.EfLockScreenService.show(UsuariosService.usuarioLogado)

                return await this.mutate(mutation, variables, options)
            }

            if (errors.networkError.statusCode === 429) {
                return this.rateLimiting.wait(() => this.mutate(mutation, variables, options), errors.networkError.response.headers.get('ttl'))
            }

            throw errors
        }
    }

    subscribe(operation, variables, callback) {
        const request = { operation, variables }
        const observer = { onResult: callback, onAbort: console.error, onError: console.error }

        const unsubscriber = () => {
            try {
                const absintheSocket = this._absintheSocket()
                const notifier = AbsintheSocket.send(absintheSocket, request)
                AbsintheSocket.unobserveOrCancel(absintheSocket, notifier, observer)
            } catch (error) {
                console.error(error)
            }
        }

        this.ensureSocketIsConnected()
            .then(() => {
                const absintheSocket = this._absintheSocket()
                const notifier = AbsintheSocket.send(absintheSocket, request)

                AbsintheSocket.observe(absintheSocket, notifier, observer)
            })

        return unsubscriber
    }

    ensureSocketIsConnected() {
        return new Promise(resolve => {
            const resolver = () => {
                this.socketIsConnected = true
                resolve()
            }

            if (this.socketIsConnected) resolver()

            const dummyOperation = `
                subscription FakeSubscription {
                    onDoesNotExist { id }
                }
            `

            const absintheSocket = this._absintheSocket()
            const notifier = AbsintheSocket.send(absintheSocket, { operation: dummyOperation })

            AbsintheSocket.observe(absintheSocket, notifier, {
                onResult: resolver,
                onError: resolver,
                onAbort: resolver
            })
        })
    }

    _absintheSocket() {
        const UsuariosService = this.$injector.get('UsuariosService')
        
        return this.EfSocket.absintheSocket(UsuariosService.token)
    }

    static deepUnfreeze(val) {
        if (Array.isArray(val)) {
            return val.map((e) => GraphQL.deepUnfreeze(e))
        } else if (val && val.constructor === Object) {
            let res = {}

            for (let key in val) if (val.hasOwnProperty(key)) {
                res[key] = GraphQL.deepUnfreeze(val[key])
            }

            return res
        } else {
            return val
        }
    }
}

angular.module('eficienciaFiscalModule').service('gql', ['EfSocket', 'renewTokenInterceptor', 'RateLimitingService', 'EfLockScreenService', '$injector', GraphQL])
